document.addEventListener('DOMContentLoaded', function() {
  /**
   * Handles the showing and hiding of the 3D request modal dialog:
   * - Opens the modal when the ".request-3d-btn" button is clicked.
   * - Closes the modal when any element with the ".close" class is clicked.
   */

  const modal = document.querySelector("dialog.request-form");
  const btnRequest3D = document.querySelector(".request-3d-btn");

  if (modal && btnRequest3D) {
    btnRequest3D.addEventListener("click", (e) => {
      e.preventDefault();
      /** @type {HTMLDialogElement} */ (modal).showModal();
    });

    const closeBtns = document.querySelectorAll(".close");

    if (closeBtns) {
      closeBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          /** @type {HTMLDialogElement} */ (modal).close();
        });
      });
    }
  }

  /**
   * Immediately searches for the Shopify Forms block on the product page.
   * If found, moves it into the custom wrapper after a brief delay.
   * Provides console logging for debugging the detection and move process.
   */

  (function() {
    // Utility to log with color and context
    /**
     * @param {string} msg
     */
    function log(msg) {
      console.log("%c[Request 3d drawing] %s", "color: green; font-weight: bold", msg);
    }

    // Check if on product page
    const isPDP = (
      document.body.classList.contains('template-product') ||
      (/** @type {any} */ (window).ShopifyForms && /** @type {any} */ (window).ShopifyForms.currentPageType === "product")
    );
    if (!isPDP) return;

    // Check container
    const wrapper = document.querySelector('.shopify-forms-custom-wrapper');
    if (!wrapper) return;

    // Function to move form immediately when found
    /**
     * @param {HTMLElement} formRoot
     */
    function moveForm(formRoot) {
      const shopifyBlock = formRoot.closest('.shopify-app-block');
      if (shopifyBlock && wrapper && !wrapper.contains(shopifyBlock)) {
        // Move immediately without delay
        wrapper.appendChild(shopifyBlock);
        log("Form moved successfully");
        return true;
      }
      return false;
    }

    // Try to move if already in DOM
    const existingForm = document.querySelector('div[data-form-root="true"]');
    if (existingForm && moveForm(/** @type {HTMLElement} */ (existingForm))) {
      log('Form moved immediately on page load');
      return;
    }

    // Enhanced mutation observer for faster detection
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const element = /** @type {Element} */ (node);
              // Check if this node or its children contain the form
              let formRoot = element.querySelector && element.querySelector('div[data-form-root="true"]');
              if (!formRoot && element.matches && element.matches('div[data-form-root="true"]')) {
                formRoot = element;
              }

              if (formRoot) {
                log("Form detected by mutation observer");
                if (moveForm(/** @type {HTMLElement} */ (formRoot))) {
                  observer.disconnect(); // Stop observing once moved
                  return;
                }
              }
            }
          }
        }
      }
    });

    // Observe with optimized settings
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Cleanup observer after reasonable time
    setTimeout(() => {
      observer.disconnect();
      log("Observer cleanup after timeout");
    }, 10000);
  })();

  /**
   * Inject styles into the shadow-dom
   *
   */
  const formContainer = document.querySelector('.form-container');
  const observer = new MutationObserver((mutationsList, observer) => {
    const form = document.querySelector('form-embed');

    if (form) {
      observer.disconnect();
      const shadow = form.shadowRoot;

      const sheet = new CSSStyleSheet();
      sheet.insertRule(`
        input, button, textarea {
          border: 1px solid #DEDEDE !important;
          border-radius: 0px !important;
          box-shadow: none !important;
        }
      `);

      sheet.insertRule(`
        input:focus, button:focus, textarea:focus, select:focus {
          outline: none !important;
          box-shadow: none !important;
        }
      `);

      if (shadow) {
        shadow.adoptedStyleSheets.push(sheet);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

});
